export const MerchandisingProgramQuoteStatusEnumValue = {
  Active: 10,
  InProcess: 30,
  Enroll: 40,
  OptedOut: 80,
  Canceled: 100,
};

export const MerchandisingProgramQuoteStatusEnum = [
  {
    value: MerchandisingProgramQuoteStatusEnumValue.Active,
    name: 'Active',
    labelFrench: 'Actif',
    labelEnglish: 'Active',
    order: 1,
  },
  {
    value: MerchandisingProgramQuoteStatusEnumValue.InProcess,
    name: 'InProcess',
    labelFrench: 'En traitement',
    labelEnglish: 'In Process',
    order: 2,
  },
  {
    value: MerchandisingProgramQuoteStatusEnumValue.Enroll,
    name: 'Enrolled',
    labelFrench: 'Inscrit',
    labelEnglish: 'Enrolled',

    order: 3,
  },
  {
    value: MerchandisingProgramQuoteStatusEnumValue.OptedOut,
    name: 'OptedOut',
    labelFrench: 'Désinscrit',
    labelEnglish: 'Opted Out',
    availableStatuses: [],
    order: 4,
  },
  {
    value: MerchandisingProgramQuoteStatusEnumValue.Canceled,
    name: 'Canceled',
    labelFrench: 'Annulé',
    labelEnglish: 'Canceled',
    order: 5,
  },
];

export default MerchandisingProgramQuoteStatusEnum;
